import { ABC, randomString } from '@lemonade-hq/ts-helpers';
import { clsx } from 'clsx';
import { useRef } from 'react';
import type { ComponentProps } from 'react';
import { Flex } from '../Flex/Flex';
import * as styles from './Icon.css';
import type { IconRecipeVariants } from './Icon.css';

export const ICON_SCOPE = 'uniclient-icon';
export const iconName = [
  'add',
  'alert',
  'alert-solid',
  'back',
  'bullet',
  'clock',
  'next',
  'checkmark',
  'checkmark-solid',
  'close',
  'close-solid',
  'circle',
  'dropdown',
  'edit',
  'eye-visible',
  'file-claim',
  'eye-not-visible',
  'info',
  'info-outlined',
  'restart',
  'location',
  'question-mark',
  'question-mark-solid',
  'search',
  'subtract',
  'three-dots',
  'calendar',
  'logout',
  'country',
  'email',
  'city',
  'birthday',
  'phone',
  'lock',
  'delete',
  'download',
  'copy',
  'facebook',
  'whatsapp',
  'messenger',
  'comment',
  'comment-outline',
  'keyboard',
  'bank',
  'creditcard',
  'sun',
  'triangular',
  'off-phone',
  'vehicle',
  'home',
  'stars',
  'send',
  'gift',
] as const;

export type IconVariant = IconRecipeVariants['variant'];
export type IconSize = IconRecipeVariants['size'];

export type IconName = (typeof iconName)[number];

export interface IconProps extends ComponentProps<'svg'>, IconRecipeVariants {
  readonly name: IconName;
  readonly containerClassName?: string;
}

export const Icon: React.FC<IconProps> = ({ name, variant, size, className, containerClassName, style, ...props }) => {
  const titleId = useRef(`icon-${name}-${randomString(5, ABC)}`);

  return (
    <Flex className={containerClassName} style={{ ...style }}>
      <svg
        aria-labelledby={titleId.current}
        className={clsx(styles.icon({ variant, size }), className)}
        {...props}
        role="img"
      >
        <title id={titleId.current}>{name}</title>
        <use className={styles.use} href={`#${ICON_SCOPE}-${name}`} />
      </svg>
    </Flex>
  );
};
